import axios from "axios";

export default {
    getTaxes: async (companyId) => {
        const {data} = await axios.get(`/${companyId}/taxes/`)
        return data
    },
    getTax: async (companyId, taxId) => {
        const {data} = await axios.get(`/${companyId}/tax/${taxId}/`)
        return data
    },
    saveTax: async (companyId, taxId, payload) => {
        const {data} = await axios.post(`/${companyId}/tax/${taxId}/`, payload)
        return data
    },

    hideTax: async (companyId, taxId) => {
        const {data} = await axios.patch(`/${companyId}/tax/${taxId}/hide/`)
        return data
    },
    archiveTax: async (companyId, taxId) => {
        const {data} = await axios.patch(`/${companyId}/tax/${taxId}/archive/`)
        return data
    },
    restoreTax: async (companyId, taxId, payload) => {
        const {data} = await axios.patch(`/${companyId}/tax/${taxId}/restore/`)
        return data
    },

    getTaxesArchive: async (companyId) => {
        const {data} = await axios.get(`/${companyId}/tax/archive/`)
        return data
    },
}
